/*
 * @Author: Suroc
 * @Date: 2024-07-11 14:15:56
 * @LastEditTime: 2025-01-11 22:54:47
 * @Description: 
 */
const vi = {
  // 头部导航
  Header: {
    SuperMarket: "CCR LAND",
    Connect: "Kết nối ví",
  },
  // 底部导航
  Footer: {
    Home: "Trang chủ",
    Mining: "Nông trại",
    Profit: "Giao dịch",
    Flst: "NFT",
    Team: "Trang cá nhân",
  },
  // 首页
  Home: {
    Account: "Tài khoản",
    Share: "Chia sẻ",
    Reference: "Người giới thiệu",
    BindWallet: "Vui lòng liên kết ví trước",
    Ecological: "Máy đào",
    Pledge: "Cầm cố",
    Conduct: "Quản lý tài sản",
    ToLoan: "Vay vốn",
    Metaverse: "Vũ trụ ảo",
    ChainGame: "Game chuỗi khối",
    ShoppingMall: "Trung tâm mua sắm",
    SwapBut: "Khám phá",
  },
  // 矿机
  Mint: {
    OnSale: "Đang bán",
    StopSelling: "Ngừng bán",
    F1MiningMachine: "Máy đào F1",
    F2MiningMachine: "Máy đào F2",
    F3MiningMachine: "Máy đào F3",
    F4MiningMachine: "Máy đào F4",
    F5MiningMachine: "Máy đào F5",
    Authorize: "Ủy quyền",
    BuyNow: "Mua ngay",
    PurchaseFLST: "Mua FLST",
  },
  // 收益
  Profit: {
    Hold: "Giá trị máy đào sở hữu",
    UnStatic: "Lợi nhuận tĩnh chưa nhận",
    UnDynamics: "Lợi nhuận động chưa nhận",
    StaticTotal: "Tổng lợi nhuận tĩnh (đã nhận)",
    DynamicTotal: "Tổng lợi nhuận động (đã nhận)",
    MyIncome: "Tổng lợi nhuận",
    Receive: "Nhận",
    MyRecord: "Lịch sử lợi nhuận của tôi",
    Money: "Số tiền (U)",
    Quantity: "Số lượng token",
    Time: "Thời gian",
  },
  // 团队
  Team: {
    SuperiorAddress: "Địa chỉ cấp trên",
    Performance: "Thành tích của tôi",
    TeamSize: "Số thành viên đội",
    Referral: "Số người giới thiệu trực tiếp",
    Direct: "Đội của tôi",
    Address: "Địa chỉ",
    Money: "Số tiền (U)",
    Time: "Thời gian",
    CopyLink: "Sao chép liên kết",
  },
  // 公共消息弹窗
  Prompt: {
    Admin: "Không có quyền truy cập",
    AdminInfo: "Lỗi lấy dữ liệu",
    AdminModified: "Sửa đổi thành công",
    AdminModification: "Sửa đổi thất bại",
    PurchaseSucceeded: "Mua thành công",
    PurchaseFailed: "Mua thất bại",
    BindingSucceeded: "Liên kết thành công",
    BindingFailed: "Liên kết thất bại",
    ConnectWallet: "Vui lòng kết nối ví trước",
    Confirm: "Xác nhận",
    Cancel: "Hủy",
    GoGetIt: "Đi nhận",
    SoldOut: "Đã bán hết",
    NotYetDev: "Chưa mở",
    NewIssueSuccess: "Nhận thành công",
    NewIssueError: "Nhận thất bại",
    TransactionErr: "Giao dịch thất bại",
    BalanceErr: "Số dư không đủ",
    USDTBalanceErr: "Số dư USDT không đủ",
    FLSTBalanceErr: "Số dư FLST không đủ",
    AllowanceErr: "Ủy quyền không đủ",
    AllowanceSuccess: "Ủy quyền thành công",
    InviteInfo1: "Bạn thông qua",
    InviteInfo2: "mời truy cập, có muốn liên kết quan hệ không?",
    ProfitInfo: "Bạn có lợi nhuận chưa nhận, vui lòng nhận trước khi mua",
    ProfitInfo2: "Bạn không có lợi nhuận chưa nhận",
    Fail: "Lỗi",
  },
  nongC: {
    Home: "Trang chủ",
    Farm: "Nông trại",
    Trade: "Giao dịch",
    NFT: "NFT",
    Mine: "Trang cá nhân",
    Share: "Chia sẻ",
    Referrer: "Người giới thiệu",
    Lv: "Cấp độ hiện tại",
    Bal: "Số dư",
    CHZSoil: "Đất đen canxi",
    KSTSoil: "Đất hạt dẻ canxi",
    SRZSoil: "Đất nâu canxi",
    GRZSoil: "Đất xám canxi",
    Plant: "Trồng",
    Harvest: "Thu hoạch",
    Buy: "Mua",
    TaxRt: "Thuế suất",
    Prc: "Giá",
    Qty: "Số lượng",
    Mkt: "Thị trường",
    Mint: "Đúc",
    BBox: "Hộp bí mật",
    BuyBBox: "Mua hộp bí mật",
    SellOrder: "Lệnh bán",
    SellMarket: "Đăng bán",
    Cancel: "Hủy",
    Claim: "Nhận",
    ContriDiv: "Cổ tức đóng góp (nhận thay)",
    EquityDiv: "Cổ tức quyền lợi (nhận thay)",
    EquityVal: "Giá trị quyền lợi",
    ContriVal: "Giá trị đóng góp",
    DivList: "Danh sách cổ tức",
    MyTeam: "Đội của tôi",
    MyDown: "Tuyến dưới",
    MyUpss: "Tuyến trên",
    TeamMaxLv: "Cấp độ cao nhất của đội",
    DirectRefPerf: "Thành tích giới thiệu trực tiếp",
    Bind: "Liên kết",
    Sale: "Bán",
    HistoryPrice: "Giá lịch sử",
    Error: "Lỗi",
  },
  common: {
    crzfh: "Cổ tức chứng nhận C",
    contri: "Cổ tức đóng góp",
    contriAmount: "Số tiền cổ tức",
    myArea: "Khu vực của tôi",
    myBind: "Liên kết của tôi",
    noBind: "Không có liên kết",
    ktAdress: "Địa chỉ khai phá",
    crz: "Chứng nhận C",
    qyz: "Giá trị quyền lợi",
    none: "Không có",
    payAmount: "Số lượng thanh toán",
    sale: "Bán",
    amount: "Số lượng",
    investment: "Đầu tư",
    released: "Đã giải phóng",
    cycle: "Chu kỳ",
    plantTime: "Thời gian trồng",
    lastHarvest: "Lần thu hoạch cuối",
    harvest: "Thu hoạch",
    hgt: "Đất đen canxi",
    lgt: "Đất hạt dẻ canxi",
    zgt: "Đất nâu canxi",
    huigt: "Đất xám canxi",
    plantNow: "Trồng ngay",
    makeSure: "Xác nhận",
    czzqsh: "Đang xử lý, vui lòng chờ...",
    ljqdts: "Tổng số ngày đăng nhập:",
    dh: "Đổi",
    wqd: "Chưa đăng nhập",
    dqd: "Chờ đăng nhập",
    kfzqdd: "Đang phát triển, vui lòng chờ",
    gqbzwjrqx: "Ví này không có quyền truy cập",
    zwkf: "Chưa mở",
    sqcg: "Ủy quyền thành công",
    sqsb: "Ủy quyền thất bại",
    zzcg: "Đúc thành công",
    zzsb: "Đúc thất bại",
    dkcg: "Mở thành công",
    dksb: "Mở thất bại",
    cg: "Thành công",
    sb: "Thất bại",
    open: "Mở",
    buy: "Mua",
    free: "Miễn phí",
    zzhqsj: "Đang lấy dữ liệu",
    zwtjr: "Không có người giới thiệu",
    destroy: "Phá hủy",
    sywcc: "Số lượng chưa sản xuất",
    dhfm: "10 ngày 23 giờ 15 phút 15 giây",
    xcrq: "Ngày tiếp theo",
    zwzsdnft: "Không có NFT đang bán",
    mc: "Tên:",
    fortyfiveDay: "50 ngày",
    token: "Token",
    price: "Giá", 
    total: "Tổng",
    uybind: "Bạn có muốn liên kết",
    zgyqmm: "mã mời này không?",
    zwyqm: "Không có mã mời",
    wcxdyqm: "Không tìm thấy mã mời",
    bindSuccess: "Liên kết hoàn tất",
    zwkf: "Chưa mở",
    lq: "Nhận",
    fail: "Thất bại",
    mygdl: "Không còn nữa",
    jine: "Số tiền:",
    shijian: "Thời gian:",
    tq: "Rút",
    tqd: "Đã rút",
    dsf: "Chờ giải phóng",
    zzsf: "Đang giải phóng",
    sfwc: "Giải phóng hoàn tất",
    jz: "Giá trị:",
    zz: "Trồng",
    zq: "Chu kỳ",
    Hour: "Giờ",
    Day: "Ngày",
    Min: "Phút",
    Sec: "Giây",
    limit: "Số lượng còn lại",
    tq: "Lấy trộm",
  },
};

export default vi;